import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaTwitter, FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import logoImage from "../../assets/images/logo.png"; // Import your image file
import razorPay from "../../assets/images/razorpay.png";
import Whatsapp from "../Floaters/Whatsapp";
import Callus from "../Floaters/Callus";
import BottomTab from "../Floaters/BottomTab";
import InterestSurveyModal from "../Floaters/Survey";

const Footer = () => {
  return (
    <footer>
      <div style={{ background: "#CC0001", padding: "2rem 1rem" }}>
        <Container>
          <Row className="text-start align-items-center">
            <Col
              md={8}
              sm={12}
              className="d-flex align-items-center mb-3 mb-md-0"
            >
              <FaWhatsapp color="#fff" size={40} className="me-3 flex-shrink-0" />
              <div className="mx-2">
                <h4 className="text-uppercase text-white fs-7">
                  Order Products via WhatsApp
                </h4>
                <p className="mb-0 text-white" style={{ fontSize: "0.8rem" }}>
                  Send us your product requirements on WhatsApp. Our team will
                  quickly assist you with pricing, availability, and order
                  confirmation.
                </p>
              </div>
            </Col>
            <Col
              md={4}
              sm={12}
              className="d-flex align-items-center justify-content-md-end"
            >
              <a
                href="https://wa.me/919686363344?text=Hello,%20I%20have%20a%20question%20about%20your%20products"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                <button
                  type="button"
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    background: "#ffffff",
                    color: "#CC0001",
                    border: "none",
                    borderRadius: "4px",
                    padding: "10px 20px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  <FaWhatsapp className="me-2" size={18} />
                  Chat on WhatsApp
                </button>
              </a>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-white py-4">
        <Container>
          <Row>
            <Col md={6}>
              <img
                src={logoImage}
                height="50"
                className="d-inline-block align-top"
                alt="Your Logo"
              />
              <p>
                <span className="fw-bold text-uppercase">
                  Headoffice: Karstar Corporation
                </span>{" "}
                <br />
                Beside Elite Hotel Near Caltex Circle, <br />
                Vinayak Nagar BH Road, <br />
                Tumakuru, Karnataka 572105.
              </p>
              <p>
                Support of Credit Cards and Payment Methods through Razorpay
                secure payment gateway
              </p>
              <img src={razorPay} alt="Payment Methods" className="img-fluid" />
            </Col>
            <Col md={2}>
              <h6>Company</h6>
              <ul className="list-unstyled">
                <li>
                  <a className="text-black" href="/">
                    Home
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/collections">
                    Products
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/aboutus">
                    About Us
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/contactus">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/store-locator">
                    Store Locator
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/track-order">
                    Orders Tracking
                  </a>
                </li>
              </ul>
            </Col>
            <Col md={2}>
              <h6>Useful Links</h6>
              <ul className="list-unstyled">
                <li>
                  <a className="text-black" href="/exchangereturnpolicy">
                    Return & Exchange Policy
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/cookiepolicy">
                    Cookie Policy
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/accessibilitypolicy">
                    Accessibility Policy
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/shippingpolicy">
                    Shipping Policy
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/communityguidelines">
                    Community Guidelines
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/copyrightnotice">
                    {" "}
                  </a>
                  Copyright Notice
                </li>
                <li>
                  <a className="text-black" href="/disclaimer">
                    Disclaimer
                  </a>
                </li>
                <li>
                  <a className="text-black" href="/contactinformation">
                    Contact Information
                  </a>
                </li>
              </ul>
            </Col>
            <Col md={2} className="text-md-end">
              <h6>Connect</h6>
              <p className="mb-0" style={{ fontSize: "0.85rem" }}>
                Karnataka:{" "}
                <a href="tel:+919686363344" className="text-decoration-none text-black">
                  +91 9686363344
                </a>
              </p>
              <p className="mb-0" style={{ fontSize: "0.85rem" }}>
                Pan India:{" "}
                <a href="tel:+919008977839" className="text-decoration-none text-black">
                  +91 9008977839
                </a>
              </p>
              <a href="mailto:info@karstar.in" className="text-decoration-none text-black mt-4">
                info@karstar.in
              </a>
              <div className="d-flex justify-content-md-end">
                <FaTwitter className="me-3" size={20} />
                <FaFacebookF className="me-3" size={20} />
                <FaInstagram size={20} />
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={6}>
              <p>© Karstar | karstar Corporation. 2024</p>
            </Col>
            <Col md={6} className="text-md-end">
              <p>
                <a
                  href="/termsandcondtions"
                  className="text-decoration-none text-black"
                >
                  Terms & Conditions
                </a>{" "}
                |
                <a
                  href="/privacypolicy"
                  className="text-decoration-none ms-2 text-black"
                >
                  Privacy Policy
                </a>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p
                className="text-muted text-center my-0"
                style={{ fontSize: "0.6rem" }}
              >
                Designed and Developed by w3builders Technology Solutions LLP
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="d-flex d-lg-none pb-5 pt-3"></div>
      {/* <div className='d-flex d-lg-none pb-5 pt-3'></div> */}
      <Whatsapp />
      <Callus />
      <BottomTab />
      <InterestSurveyModal />
    </footer>
  );
};

export default Footer;
